// = Libs =
import { FC } from 'react';

import classes from './poll-info.module.scss';
import HtmlParser from 'react-html-parser';
import formatDate from '@/helpers/formatDate';
import { SplitContent } from '@/common/containers/split-content/split-content';
import Button from '@/common/components/ui/buttons/button/button';
import { createReport } from '@/services/report.service';
import { withAlert } from '@/helpers/notificationHelper';
import { mutate } from 'swr';

interface PollInfoInterface {
  finishDate: string;
  description: string;
  executorId?: number;
  pollId: number;
  isPublic?: boolean;
}

const genSidebar = (pollId: number, executorId: number, isPublic: boolean) => {
  return (
    <div>
      <Button
        onClick={() =>
          withAlert(() => {
            const res = createReport(pollId, executorId, isPublic);
            mutate(`monitoring-api/polls/${pollId}/with-report/${executorId}`);
            return res;
          })
        }
        color={'primary'}>
        Приступить к заполнению
      </Button>
    </div>
  );
};

const PollInfo: FC<Partial<PollInfoInterface>> = ({
  finishDate = '',
  description = '',
  executorId,
  pollId = 0,
  isPublic = false,
}) => {
  return (
    <SplitContent
      SideBar={executorId ? genSidebar(pollId, executorId, isPublic) : <div />}
      Content={
        <div>
          <div className={classes['title']}>
            <h1 className={classes['title-h1']}>О мониторинге</h1>
          </div>
          <div className={classes['text']}>{HtmlParser(description)}</div>
          <p>Срок приема ответов: {formatDate(finishDate)}</p>
        </div>
      }
      Position={true}
    />
  );
};

export default PollInfo;
